"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZTextBox = void 0;
const React = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
const LocalizedComponent_1 = require("../../languages/LocalizedComponent");
const __1 = require("../");
const styled_components_1 = __importDefault(require("styled-components"));
class ZTextBoxComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            raisedLabel: props.value || props.placeholder || props.defaultValue
                ? true
                : false,
            value: props.value || props.defaultValue,
            hovered: false
        };
        this.boundOnFocusHandler = this.onFocusHandler.bind(this);
        this.boundOnBlurHandler = this.onBlurHandler.bind(this);
        this.boundClearHandler = this.clearHandler.bind(this);
        this.input = React.createRef();
    }
    render() {
        const { Id, ignoreFVS, editable, sortOrder, ...otherProps } = this
            .props;
        return (React.createElement(__1.RequiredDot, { required: this.props.required, raised: this.state.raisedLabel, raisedTransform: "down-10 right-4", loweredTransform: "down-26 left-2" },
            React.createElement("span", { className: [
                    this.props.className,
                    this.state.hovered ? "hovered" : "",
                    "z-component z-textbox"
                ].join(" "), onMouseEnter: e => this.setState({ hovered: true }), onMouseLeave: e => this.setState({ hovered: false }) },
                React.createElement("span", { className: "z-textbox-icon" }, this.props.icon ? (React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: this.props.icon })) : null),
                this.state.value &&
                    this.state.hovered &&
                    !this.props.disabled &&
                    !this.props.readOnly ? (React.createElement("span", { className: "k-icon k-clear-value k-i-close z-clear-button", role: "button", tabIndex: -1, title: "clear", onClick: this.boundClearHandler })) : null,
                React.createElement("span", null,
                    React.createElement(LocalizedComponent_1.LocalizedComponent, Object.assign({}, otherProps),
                        React.createElement(kendo_react_inputs_1.Input, { label: this.props.label || " ", onFocus: this.boundOnFocusHandler, onBlur: this.boundOnBlurHandler, onChange: e => {
                                this.setState({ value: e.target.value });
                                this.props.onChange && this.props.onChange(e);
                            }, className: this.props.className, ref: this.input }))))));
    }
    componentDidUpdate() {
        if (this.props.disabled &&
            this.input.current &&
            this.input.current.element &&
            this.input.current.element.parentElement) {
            this.input.current.element.parentElement.classList.remove("k-state-focused");
        }
    }
    componentDidMount() {
        if (this.props.disabled &&
            this.input.current &&
            this.input.current.element &&
            this.input.current.element.parentElement) {
            this.input.current.element.parentElement.classList.remove("k-state-focused");
        }
    }
    onFocusHandler(event) {
        this.setState({ raisedLabel: true });
        this.props.onFocus && this.props.onFocus(event);
    }
    onBlurHandler(event) {
        this.setState({
            raisedLabel: event.target.value ? true : false,
            value: event.target.value
        });
        this.props.onBlur && this.props.onBlur(event);
    }
    clearHandler(event) {
        event.preventDefault();
        this.input &&
            this.input.current &&
            this.input.current.setState({ value: "" });
        this.setState({ value: "", raisedLabel: false });
        this.props.onChange &&
            this.props.onChange({ target: { value: "" } }, "");
    }
    setValue(value) {
        this.input &&
            this.input.current &&
            this.input.current.setState({ value: value || "" });
        this.setState({ value: value || "", raisedLabel: !!value });
        this.props.onChange &&
            this.props.onChange({ target: { value: value || "" } }, value || "", false);
    }
}
exports.ZTextBox = styled_components_1.default(ZTextBoxComponent) `
   padding: 10px;
   display: inline-block;
   position: relative;

   & .k-textbox-container.k-textbox-container.k-textbox-container {
      width: ${props => (props.width ? `${props.width}px` : "200px")};
   }
   &.k-textbox.k-textbox {
      margin: 0px;
      padding: 8px 35px 8px 3px;
      & + .k-label.k-label {
         margin: 0px 3px 0px 5px;
      }
      &:hover:not(:disabled),
      .hovered &:not(:disabled) {
         border-bottom-color: rgba(0, 0, 0, 0.87);
         background: ${props => props.valid === false
    ? props.theme["validation-background-color"]
    : props.theme["input-background-hover-color"]};
      }
   }
   & .z-textbox-icon.z-textbox-icon {
      float: right;
      position: absolute;
      right: 36px;
      bottom: 36px;
      z-index: 2;
      color: ${props => props.disabled
    ? props.theme["disabled-color"]
    : props.theme["input-color"]};
      opacity: ${props => (props.disabled ? 0.6 : 1.0)};
   }
   & .z-clear-button.z-clear-button {
      right: ${props => (props.icon ? 34 : 12)}px;
      position: absolute;
      bottom: 12px;
      opacity: 0.5;
      z-index: 2;
      cursor: pointer;
   }
`;
//# sourceMappingURL=ZTextBox.js.map